import { useContext } from 'react';

import { routes } from '../constants';
import { CookiebotContext } from '../state/CookiebotContextProvider';
import { isFeatureEnabled } from './feature';
import useRouter from './useRouter';
import useScreenSize from './useScreenSize';

const useIntercom = () => {
	const consent = useContext(CookiebotContext);

	const isIntercomEnabled = isFeatureEnabled('intercom') && consent.marketing;
	const { isXsScreen } = useScreenSize();

	const {
		match: {
			location: { pathname },
		},
	} = useRouter();

	const isPublicReaderPage = pathname.includes(`/${routes.publicReader.root}/`);

	return {
		isIntercomVisible: isIntercomEnabled && !isXsScreen && !isPublicReaderPage,
	};
};

export default useIntercom;
